import React, { useEffect, useState } from "react";
import { Container, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../SignUp/onBoarding/religion.css";

import religionIcon from "../../../../../assets/images/religion.png";

import { API_URL } from "../../../../../api";
import { useCookies } from "../../../../../hooks/useCookies";
import Sidebar from "../../../../userflow/components/sidebar/sidebar";
import { useProfile } from "../../../../userflow/components/context/ProfileContext";
import { showAlert } from "../../../../../utils/alertUtils";

export const ReligionUpdate = () => {
  const { updateProfile } = useProfile();
  const { getCookie } = useCookies();
  const [allReligions, setAllReligions] = useState([]);
  const [selectedReligion, setSelectedReligion] = useState(null);
  const [allLanguages, setAllLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const navigate = useNavigate();
  const approvalstatus = getCookie("approval");

  useEffect(() => {
    fetch(`${API_URL}customer/users/religions`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then(response => response.json())
      .then(data => {
        setAllReligions(data.religions);
        if (data.userReligion) {
          setSelectedReligion(data.userReligion.name);
        }
      })
      .catch(error => {
        console.error("Error fetching religions:", error);
      });

    fetch(`${API_URL}customer/users/language`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then(response => response.json())
      .then(data => {
        setAllLanguages(data.languages);
      })
      .catch(error => {
        console.error("Error fetching languages:", error);
      });

    fetch(`${API_URL}customer/users/userlanguage`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
    })
      .then(response => response.json())
      .then(data => {
        setSelectedLanguages(
          data.selectedLanguages.map(lang => lang.language_id)
        );
      })
      .catch(error => {
        console.error("Error fetching user languages:", error);
      });
  }, []);

  const handleLanguageClick = languageId => {
    setSelectedLanguages(prevSelected => {
      if (prevSelected.includes(languageId)) {
        return prevSelected.filter(id => id !== languageId);
      } else {
        return [...prevSelected, languageId];
      }
    });
  };

  const handleReligionClick = e => {
    e.preventDefault();

    const religionId = allReligions.find(r => r.name === selectedReligion)?.id;

    if (religionId) {
      fetch(`${API_URL}customer/users/religions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
        body: JSON.stringify({ religionId }),
      })
        .then(response => response.json())
        .then(async data => {
          await updateProfile("update");
          if (approvalstatus === "PENDING") {
            showAlert("Success", "Approval request sent!", () =>
              navigate("/user/home")
            );
          } else {
            showAlert("Success", "Successfully updated", () =>
              navigate("/updateprofile")
            );
          }
        })
        .catch(error => {
          console.error("Error updating religion:", error);
        });
    }
    fetch(`${API_URL}customer/users/language`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },

      body: JSON.stringify({ languages: selectedLanguages }),
    })
      .then(response => response.json())
      .then(async data => {
        await updateProfile("update");
        if (approvalstatus === "PENDING") {
          showAlert("Success", "Approval request sent!", () =>
            navigate("/user/home")
          );
        } else {
          showAlert("Success", "Successfully updated", () =>
            navigate("/updateprofile")
          );
        }
      })
      .catch(error => {
        console.error("Error updating languages:", error);
      });
  };

  return (
    <Sidebar>
      <div
        style={{
          flex: "1",
          marginInline: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",

          padding: "2rem",
        }}
      >
        <div className="religion-container" style={{ overflow: "hidden" }}>
          <Container className="religion-main">
            <Container className="religion-content">
              <Container className="religion-details">
                <div className="your-religion">
                  <Container className="religion-text">
                    <Image
                      className="about-yourself-icon"
                      src={religionIcon}
                    ></Image>
                    <p>What are your religious beliefs?</p>
                  </Container>
                  <Container
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      maxHeight: "39vh",
                      overflowY: "auto",
                      borderRadius: "8px",
                      padding: "10px",
                      width: "100%",
                      paddingRight: "calc(1.5rem * 0.5)",
                      paddingLeft: "calc(1.5rem * 0.5)",
                      marginRight: "auto",
                      marginLeft: "auto",
                    }}
                  >
                    {allReligions.map((religion, index) => (
                      <div
                        key={index}
                        className={`religion-item ${
                          selectedReligion === religion.name ? "active" : ""
                        }`}
                        onClick={() => setSelectedReligion(religion.name)}
                      >
                        {religion.name}
                      </div>
                    ))}
                  </Container>
                </div>
              </Container>
              <div
                className="d-flex justify-content-center"
                style={{
                  position: "fixed",
                  bottom: "30px",
                  width: "100%",
                  gap: "30px",
                }}
              >
                <button
                  className="global-cancel-button"
                  onClick={e => {
                    e.preventDefault();
                    navigate("/updateprofile");
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="global-save-button"
                  onClick={handleReligionClick}
                >
                  Save
                </button>
              </div>
            </Container>
          </Container>
        </div>
      </div>
    </Sidebar>
  );
};
